import React from 'react';
import './InstructionsModal.css';

const INSTRUCTIONS_IMAGE = 'https://customer-assets.emergentagent.com/job_yoga-sadhana-1/artifacts/ac7v0r5r_isha_smk_basics.JPG';

export const InstructionsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="instructions-overlay" onClick={onClose}>
      <div className="instructions-modal" onClick={(e) => e.stopPropagation()}>
        <button 
          className="instructions-close-btn"
          onClick={onClose}
          aria-label="Close instructions"
          data-testid="instructions-close-btn"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
        <img 
          src={INSTRUCTIONS_IMAGE} 
          alt="Daily Practice Instructions" 
          className="instructions-image"
          data-testid="instructions-image"
        />
      </div>
    </div>
  );
};

export default InstructionsModal;
